import { render, staticRenderFns } from "./organization_xp.vue?vue&type=template&id=641f5350&scoped=true&"
import script from "./organization_xp.vue?vue&type=script&lang=js&"
export * from "./organization_xp.vue?vue&type=script&lang=js&"
import style0 from "./organization_xp.vue?vue&type=style&index=0&id=641f5350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f5350",
  null
  
)

export default component.exports